import { jsx as _jsx } from "react/jsx-runtime";
import translationEng from '../locales/en/en_US.json';
import translationFre from '../locales/fr/fr-CA.json';
import { I18nextProvider as Provider, initReactI18next } from 'react-i18next';
import i18n from 'i18next';
i18n.use(initReactI18next).init({
    debug: false,
    lng: 'fr',
    fallbackLng: 'en',
    keySeparator: false,
    interpolation: {
        escapeValue: false,
    },
    returnObjects: true,
    resources: {
        en: { translations: translationEng },
        fr: { translations: translationFre },
    },
    ns: ['translations'], // Separate the namespaces with individual strings in an array
    defaultNS: 'translations',
    react: {
        useSuspense: true,
    },
});
export const I18NextProvider = ({ children }) => {
    return _jsx(Provider, { i18n: i18n, children: children });
};
//# sourceMappingURL=I18NextProvider.js.map